import React from 'react'
import PropTypes from 'prop-types'
import { AS, getMaxCount } from '../../config/account'
import { dateFromDate } from '../../utils/datesTimes'

export class AccountCD extends React.Component {
  render () {
    const { account } = this.props
    const { as, c, exd, o, regData } = account
    const r = 'c-r'
    let clsC = null
    let clsD = null
    if (o) {
      switch (as) {
        case AS.DEMO_OC:
        case AS.WAITTING_D_OC:
        case AS.WAITTING_F_OC:
        case AS.FULL_OC:
          clsC = r
          break
        case AS.WAITTING_F_OD:
        case AS.FULL_OD:
          clsD = r
          break
        default:
      }
    }
    let maxC = getMaxCount(regData.subscription, as, true, regData.prevSubscription)
    const fc = Intl.NumberFormat().format(c)
    let dateInfo = null
    if (exd) {
      dateInfo = <p>Platnost předplatného do <span className={clsD}>{dateFromDate(exd)}</span></p>
    }
    return (
      <React.Fragment>
        <p>Počet uložených parcel <span className={clsC}>{fc}</span>/{`${maxC}`}</p>
        {dateInfo}  
      </React.Fragment>
    )
  }
}

AccountCD.propTypes = {
  account: PropTypes.object
}

export default AccountCD



// WEBPACK FOOTER //
// ./src/components/User/UserInfoAccountCD.js